import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';

/**
 * Error Boundary para capturar errores de React y evitar pantallas en blanco
 * Muestra un mensaje amigable y permite recargar la página
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Actualizar el estado para que el siguiente renderizado muestre la UI de error
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Registrar el error
    console.error('ErrorBoundary capturó un error:', error, errorInfo);
    
    this.setState({
      error,
      errorInfo
    });

    // Aquí podrías enviar el error a un servicio de monitoreo
    // Ejemplo: logErrorToService(error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleReset = () => {
    this.setState({ 
      hasError: false,
      error: null,
      errorInfo: null
    });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="container mt-5">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="card border-danger">
                <div className="card-header bg-danger text-white">
                  <h4 className="mb-0">
                    <FaExclamationTriangle className="me-2" />
                    Ups! Algo salió mal
                  </h4>
                </div>
                <div className="card-body">
                  <p className="lead">
                    Lo sentimos, ha ocurrido un error inesperado.
                  </p>
                  <p>
                    No se preocupe, sus datos están seguros. Puede intentar recargar la página
                    o contactar con soporte si el problema persiste.
                  </p>
                  
                  {process.env.NODE_ENV === 'development' && this.state.error && (
                    <details className="mt-3">
                      <summary className="btn btn-sm btn-outline-secondary">
                        Ver detalles técnicos
                      </summary>
                      <div className="mt-3 p-3 bg-light border rounded">
                        <h6>Error:</h6>
                        <pre className="text-danger">
                          {this.state.error.toString()}
                        </pre>
                        
                        {this.state.errorInfo && (
                          <>
                            <h6 className="mt-3">Stack Trace:</h6>
                            <pre className="small">
                              {this.state.errorInfo.componentStack}
                            </pre>
                          </>
                        )}
                      </div>
                    </details>
                  )}

                  <div className="mt-4">
                    <button 
                      className="btn btn-primary me-2"
                      onClick={this.handleReload}
                    >
                      Recargar Página
                    </button>
                    <button 
                      className="btn btn-outline-secondary"
                      onClick={this.handleReset}
                    >
                      Intentar Continuar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
